function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeed3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(229, 26, 148)",
      fill: "rgb(229, 26, 148)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "13.9819px"
    },
    transform: "matrix(-0.719964, 0.317171, -0.317171, -0.719964, 818.77594, 426.84491)",
    d: "M 774.155 310.234 A 276.086 276.086 0 1 1 570.984 221.084 L 570.984 230.573 A 266.597 266.597 0 1 0 767.172 316.659 Z",
    bxShape: "pie 570.984 497.17 266.597 276.086 47.383 360 1@2c08b409"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "rgb(31, 48, 109)",
      stroke: "rgb(31, 48, 109)",
      strokeWidth: "41.9353px"
    },
    transform: "matrix(-0.567385, 0.249954, -0.249954, -0.567385, 698.237488, 389.367065)",
    d: "M 774.155 310.234 A 276.086 276.086 0 1 1 465.135 242.181 L 468.773 250.945 A 266.597 266.597 0 1 0 767.172 316.659 Z",
    bxShape: "pie 570.984 497.17 266.597 276.086 47.383 337.456 1@7671cd7f"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "rgb(229, 26, 148)"
    },
    cx: 250,
    cy: 250,
    r: 17.381
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      strokeLinejoin: "round",
      strokeLinecap: "round",
      stroke: "rgb(229, 26, 148)",
      strokeWidth: 18
    },
    x1: 198.202,
    y1: 198.204,
    x2: 249.492,
    y2: 249.494,
    transform: "matrix(-0.999998, 0.002233, -0.002233, -0.999998, 500.259243, 498.942261)",
    bxOrigin: "1.007 1.005"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgba(31, 48, 109, 0.74)",
      stroke: "rgb(142, 151, 185)",
      strokeWidth: 3,
      strokeLinecap: "round"
    },
    x1: 250,
    y1: 286.188,
    x2: 250,
    y2: 305.173,
    transform: "matrix(0.707107, 0.707107, -0.707107, 0.707107, 163.889899, -17.499287)"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgba(31, 48, 109, 0.74)",
      stroke: "rgb(142, 151, 185)",
      strokeWidth: 3,
      strokeLinecap: "round"
    },
    x1: 94.105,
    y1: 303.178,
    x2: 94.105,
    y2: 322.163,
    transform: "matrix(0.358908, 0.933373, -0.933373, 0.358908, 352.168248, 112.615619)"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgba(31, 48, 109, 0.74)",
      stroke: "rgb(142, 151, 185)",
      strokeWidth: 3,
      strokeLinecap: "round"
    },
    x1: 80.929,
    y1: 240.478,
    x2: 80.929,
    y2: 259.463,
    transform: "matrix(0, 1, -1, 0, 330.899506, 169.041504)"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgba(31, 48, 109, 0.74)",
      stroke: "rgb(142, 151, 185)",
      strokeWidth: 3,
      strokeLinecap: "round"
    },
    x1: 94.01,
    y1: 176.257,
    x2: 94.01,
    y2: 195.242,
    transform: "matrix(-0.393046, 0.919519, -0.919519, -0.393046, 301.760419, 172.313611)"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgba(31, 48, 109, 0.74)",
      stroke: "rgb(142, 151, 185)",
      strokeWidth: 3,
      strokeLinecap: "round"
    },
    x1: 130.184,
    y1: 120.983,
    x2: 130.184,
    y2: 139.968,
    transform: "matrix(-0.707107, 0.707107, -0.707107, -0.707107, 314.498111, 130.681621)"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgba(31, 48, 109, 0.74)",
      stroke: "rgb(142, 151, 185)",
      strokeWidth: 3,
      strokeLinecap: "round"
    },
    x1: 186.873,
    y1: 83.868,
    x2: 186.873,
    y2: 102.853,
    transform: "matrix(-0.926769, 0.375632, -0.375632, -0.926769, 395.130281, 109.68858)"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgba(31, 48, 109, 0.74)",
      stroke: "rgb(142, 151, 185)",
      strokeWidth: 3,
      strokeLinecap: "round"
    },
    x1: 250.031,
    y1: 71.376,
    x2: 250.031,
    y2: 90.361,
    transform: "matrix(-1, 0, 0, -1, 500.062012, 161.737)"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgba(31, 48, 109, 0.74)",
      stroke: "rgb(142, 151, 185)",
      strokeWidth: 3,
      strokeLinecap: "round"
    },
    x1: 314.1,
    y1: 84.726,
    x2: 314.1,
    y2: 103.711,
    transform: "matrix(-0.924761, -0.380549, 0.380549, -0.924761, 568.712541, 300.878596)"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgba(31, 48, 109, 0.74)",
      stroke: "rgb(142, 151, 185)",
      strokeWidth: 3,
      strokeLinecap: "round"
    },
    x1: 369.495,
    y1: 121.057,
    x2: 369.495,
    y2: 140.042,
    transform: "matrix(-0.707107, -0.707107, 0.707107, -0.707107, 538.454973, 484.134359)"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgba(31, 48, 109, 0.74)",
      stroke: "rgb(142, 151, 185)",
      strokeWidth: 3,
      strokeLinecap: "round"
    },
    x1: 406.749,
    y1: 177.203,
    x2: 406.749,
    y2: 196.188,
    transform: "matrix(-0.37998, -0.924995, 0.924995, -0.37998, 388.613071, 633.876722)"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgba(31, 48, 109, 0.74)",
      stroke: "rgb(142, 151, 185)",
      strokeWidth: 3,
      strokeLinecap: "round"
    },
    x1: 419.035,
    y1: 240.191,
    x2: 419.035,
    y2: 259.176,
    transform: "matrix(0, -1, 1, 0, 169.351509, 668.718498)"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "rgba(31, 48, 109, 0.74)",
      stroke: "rgb(142, 151, 185)",
      strokeWidth: 3,
      strokeLinecap: "round"
    },
    x1: 406.27,
    y1: 304.598,
    x2: 406.27,
    y2: 323.583,
    transform: "matrix(0.388007, -0.921657, 0.921657, 0.388007, -40.849089, 566.662621)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeed3);
export default __webpack_public_path__ + "static/media/Speed3.d7e2e67718202aa638612d45878b76dd.svg";
export { ForwardRef as ReactComponent };